import { render, staticRenderFns } from "./RegisteredCards.vue?vue&type=template&id=2240dcd8"
import script from "../controllers/RegisteredCards.ts?vue&type=script&lang=ts&external"
export * from "../controllers/RegisteredCards.ts?vue&type=script&lang=ts&external"
import style0 from "./RegisteredCards.vue?vue&type=style&index=0&id=2240dcd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports